<!--
 * @message: 时间线，
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-15 17:16:10
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_TimeLine.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-17 13:08:21
-->
<template>
  <v-container fluid class="pa-0 py-2" style="min-height: calc(100% - 36px)">
    <!-- <v-divider v-if="shiftData.length == 0"></v-divider> -->

    <noContent v-if="shiftData.length == 0" />
    <v-sheet
      width="100%"
      height="auto"
      v-for="(item, index) in shiftData"
      :key="`myshift--${index}`"
      class="d-flex justify-start flex-column py-2"
    >
      <v-sheet class="px-2 d-flex justify-start flex-row">
        <v-sheet width="40" height="auto" color="transparent">
          <v-btn :ripple="false" icon style="background: #ffdec0">
            <svg-icon size="20" fill="rgba(0,0,0,0.87)" iconClass="punch" />
          </v-btn>
        </v-sheet>
        <v-container class="pa-0 ml-1 text-left mr-12" fluid>
          <!-- man -->
          <v-chip
            pill
            class="py-2 px-0 pr-2"
            v-if="item && !item.is_master"
            style="height: 36px"
          >
            <!-- <v-sheet class="pa-1 " color='grey lighten-3'></v-sheet> -->
            <StaffAvatar
              size="30"
              :src="item['staff_avatar']"
              :staff_name="$getCommonLangValue(item.preferred_name)"
            />

            <span class="text-body-2 ml-1">{{
              $getCommonLangValue(item.preferred_name)
            }}</span>
            <!-- <span class="text--secondary text-caption-xs"> {{ item.staff_code }}</span> -->
          </v-chip>
          <!-- shift  -->
          <v-sheet class="px-1 text-subtitle-2 my-2">
            {{ $getCommonLangValue(item["official_shift_abbr"]) }}
          </v-sheet>
          <!-- site -->
          <v-sheet
            class="d-flex justify-start align-center my-2"
            v-if="item.site_uuid"
          >
            <svg-icon
              size="20"
              fill="rgba(0,0,0,0.54)"
              iconClass="site"
              className="flex-shrink-1"
            />
            <div
              class="mx-2 text--secondary text-ellipsis-2"
              style="width: calc(100% - 20px)"
            >
              {{ $getCommonLangValue(item.site_name) }}
            </div>
          </v-sheet>
          <!-- time -->
          <v-sheet class="d-flex justify-start align-center my-2">
            <i
              class="material-icons-round md-20"
              style="color: rgba(0, 0, 0, 0.54)"
              >access_time</i
            >
            <v-sheet
              width="100"
              height="30"
              class="
                rounded
                justify-center
                d-flex
                align-center
                mx-2
                px-2
                text-h5
              "
              :class="
                item['actual_punch_in_uuid']
                  ? 'grey lighten-3 text--primary  '
                  : ' mrc-border-solid   text--secondary'
              "
              >{{
                $getDateTime(
                  item["actual_punch_in_uuid"]
                    ? item["official_punch_in_utc_datetime"]
                    : item["official_start_utc_time"],
                  "HH:mm"
                )
              }}</v-sheet
            >
            <!-- <v-chip class="rounded" small >{{
            $getDateTime(item["official_punch_in_utc_datetime"], "HH:mm")
          }}</v-chip> -->
            <span> - </span>
            <v-sheet
              width="100"
              height="30"
              class="
                rounded
                px-2
                mx-2
                justify-center
                d-flex
                align-center
                text-h5
              "
              :class="
                item['actual_punch_out_uuid']
                  ? 'grey lighten-3 text--primary '
                  : ' mrc-border-solid  text--secondary'
              "
              >{{
                $getDateTime(
                  item["actual_punch_out_uuid"]
                    ? item["official_punch_out_utc_datetime"]
                    : item["official_end_utc_time"],
                  "HH:mm"
                )
              }}</v-sheet
            >
          </v-sheet>
          <!-- leave remark -->
          <v-sheet
            class="d-flex justify-start align-center my-2"
            v-if="item.leave_type_remark_uuid"
          >
            <span
              class="material-icons-round md-20 flex-shrink-1"
              style="color: rgba(0, 0, 0, 0.54)"
              >event</span
            >

            <div
              class="mx-2 text--secondary text-ellipsis-2"
              style="width: calc(100% - 20px)"
              :title="$getCommonLangValue(item.leave_type_remark_name)"
            >
              {{ $getCommonLangValue(item.leave_type_remark_name) }}
            </div>
          </v-sheet>
          <!-- remark -->
          <v-sheet
            class="d-flex justify-start align-start my-2 flex-row"
            v-if="item.remarks"
          >
            <svg-icon
              className="flex-shrink-1 flex-grow-1"
              size="20"
              fill="rgba(0, 0, 0, 0.54)"
              iconClass="mini_doc"
            />

            <div
              class="mx-2 text--secondary text-ellipsis-2"
              style="width: calc(100% - 20px)"
              :title="$getCommonLangValue(item.remarks)"
            >
              {{ $getCommonLangValue(item.remarks) }}
            </div>
          </v-sheet>
          <!-- tag-->
          <v-sheet class="px-1 my-2" v-if="item">
            <v-chip
              small
              v-if="Number(item.is_late)"
              :color="$getTagColors($card_line_colors, 'is_late_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_lateLabel") }}({{
                item.official_total_late_minutes || 0
              }}
              {{ $t("label_essweb_system_minutesLabel") }})</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_ot)"
              :color="$getTagColors($card_line_colors, 'is_ot_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_otLabel") }}({{
                item.official_total_ot_minutes || 0
              }}
              {{ $t("label_essweb_system_minutesLabel") }})</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_early_leave)"
              :color="$getTagColors($card_line_colors, 'is_early_leave_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_earlyLeaveLabel") }}({{
                item.official_total_early_leave_minutes || 0
              }}
              {{ $t("label_essweb_system_minutesLabel") }})</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_absense)"
              :color="$getTagColors($card_line_colors, 'is_absense_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_absenseLabel") }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_work_from_home)"
              :color="$getTagColors($card_line_colors, 'is_work_from_home_1')"
              class="ma-1 text--primary"
              >{{
                $t("label_essweb_punchRecord_list_tag_workFromHomeLabbel")
              }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_locked)"
              :color="$getTagColors($card_line_colors, 'is_locked_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_isLockedLabel") }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_adhoc)"
              :color="$getTagColors($card_line_colors, 'is_adhoc_1')"
              class="ma-1 text--primary"
              >{{ $t("label_essweb_system_tag_label_isAdhocLabel") }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_missing_punch)"
              :color="$getTagColors($card_line_colors, 'is_missing_punch_1')"
              class="ma-1 white--text"
              >{{
                $t("label_essweb_system_tag_label_isMissingPunchLabel")
              }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_out_of_office)"
              :color="$getTagColors($card_line_colors, 'is_out_of_office_1')"
              class="ma-1 text--primary"
              >{{
                $t("label_essweb_system_tag_label_isOutOfOfficeLabel")
              }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_onDuty)"
              :color="$getTagColors($card_line_colors, 'is_on_duty_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_isOnDutyLabel") }}</v-chip
            >
            <v-chip
              small
              :color="leave.color_code"
              outlined
              v-for="(leave, index) in item.leave_info"
              :key="`leave--${index}`"
              class="ma-1"
              >{{ $getCommonLangValue(leave["leave_type_name"]) }}</v-chip
            >
            <v-chip
              small
              :color="$getTagColors($card_line_colors, 'is_holiday_1')"
              v-for="(holiday, index) in item.holiday_info"
              :key="`holiday--${index}`"
              class="ma-1 text--primary"
              >{{ $getCommonLangValue(holiday["holiday_name"]) }}</v-chip
            >
          </v-sheet>

          <v-divider v-if="item && !item.is_master" class="mt-3"></v-divider>
        </v-container>
      </v-sheet>

      <v-divider v-if="item && item.is_master" class="mt-3"></v-divider>
    </v-sheet>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "TimeLine",
  computed: {
    ...mapGetters(["companyLang", "defaultUTC", "AppInfo"]),
  },
  props: {
    curDate: { default: "", type: String },
  },
  watch: {
    curDate(val) {
      if (val) this.getMyShift(val);
    },
  },
  mounted() {
    if (this.curDate) {
      this.getMyShift(this.curDate);
    }
  },
  data() {
    return {
      shiftData: [],
    };
  },
  methods: {
    getMyShift: function (date) {
      const that = this;
      // that.shiftData = [];
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_master",
        url: "/home-page/get-agenda/",
        data: {
          start_date: this.$getTimeValue(date),
          // end_date: this.$getTimeValue(date + " 23:59:59"),
        },
        type: "client",
        notAlert: true,
      })
        .then((res) => {
          if (res.data["subordinate"] && res.data["master"]) {
            res.data["master"]["is_master"] = true;
            that.shiftData = [res.data["master"]].concat(
              res.data["subordinate"]
            );
          } else {
            if (res.data["master"] && !res.data["subordinate"]) {
              res.data["master"]["is_master"] = true;
              that.shiftData = [res.data["master"]];
            }
            if (res.data["subordinate"] && !res.data["master"]) {
              that.shiftData = res.data["subordinate"];
            }
            if (!res.data["master"] && !res.data["subordinate"]) {
              that.shiftData = [];
            }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

